import { Huddle } from 'lib/generated/graphql';
import Image from 'next/image';
import React from 'react';

const DEFAULT_USER_AVATAR = process.env.DEFAULT_USER_AVATAR || '';

const TeamButton = ({ huddle, openTeamModal }: { huddle: Huddle; openTeamModal: () => void }) => {
  return (
    <div onClick={openTeamModal}>
      <button className="flex justify-center border border-[#C4C4C4] w-full sm:w-fit rounded-lg px-3 py-2.5 text-[#595959] shadow">
        <div className={`z-30 h-6 w-6 relative rounded-lg outline outline-2 outline-white`}>
          <Image className="rounded-lg" layout="fill" src={huddle?.teamLead?.photoUrl || DEFAULT_USER_AVATAR} />
        </div>
        <div className={`z-20 -ml-1 h-6 w-6 rounded-lg bg-[#FFF8E7] outline outline-2 outline-white`}>⚡</div>
        <div className={`z-10 -ml-1 h-6 w-6 rounded-lg bg-[#FFF8E7] outline outline-2 outline-white`}>⚡</div>
        <div className="ml-1 text-[#595959] font-medium">The team</div>
      </button>
    </div>
  );
};

export default TeamButton;
